import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
//import App from './views/PackagePrediction/PackagePrediction';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
